<template>
  <diet-schedules-list
    :meta="meta"
    :id="id"
    :type="type"
    :initialDayID="initialDayID"
    :programDetails="ProgramDetails.data">
  </diet-schedules-list>
</template>

<script>
import { mapActions } from 'vuex';
import { first, isNil, find, get } from 'lodash';

import { PROGRAMS_KEYS } from 'constants/types';

import PageProps from 'components/mixins/page-props';

// import NuttremaLayoutCred from 'components/ui/layout/nuttrema-layout-cred';

import DietSchedulesList from './cmpt-diet-schedules-list';

export default {
  name: 'page-diet-schedules',
  mixins: [
    PageProps,
  ],
  props: {
    id: {
      required: true,
      default: null,
    },
    dayID: {
      required: false,
      default: null,
    },
    type: {
      required: false,
      default: PROGRAMS_KEYS.diet,
    },
  },
  components: {
    // NuttremaLayoutCred,
    DietSchedulesList,
  },
  methods: {
    ...mapActions([
      'RecreateProgramDaySummary',
    ]),
  },
  computed: {
    ProgramDetails() {
      return this.$store.getters.ProgramDetails(this.id);
    },
    initialDayID() {
      const day = isNil(this.dayID) ? first(this.ProgramDetails.data.ProgramDays) : find(this.ProgramDetails.data.ProgramDays, item => Number(item.id) === Number(this.dayID));
      return get(day, 'id', null);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/programs/diets/details/shedules/page-diet-schedules.vue